import React from 'react';

import { IconTile } from '@atlaskit/icon';
import type { GlyphProps } from '@atlaskit/icon/types';
import LinkIcon from '@atlaskit/icon/core/link';

export const SmartLinkEmbed24Icon = (props: GlyphProps) => {
	const label = props.label || '';
	return (
		<IconTile
			key="smartLinkEmbed"
			label={label}
			appearance="limeBold"
			shape="square"
			size="24"
			icon={LinkIcon}
			testId={props.testId}
		/>
	);
};
